import Component from "@lib/Component.js";
import { addEvent, removeEvent, addClass, removeClass } from "@qneyraud/q-utils";
import { gsap, ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

export default class ScrollTop extends Component {
  init() {
    super.init();
    this.bindMethods();

    this.shown = false;
  }

  bindMethods() {
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onTick = this.onTick.bind(this);
  }

  onEnter() {
    super.onEnter();
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    addEvent(this.el, "click", this.onButtonClick);
    this.$bus.on("tick", this.onTick);
  }

  onButtonClick() {
    this.scrollToTop();
  }

  scrollToTop() {
    // 1s every 2000px
    const duration = window.pageYOffset / 2000;

    const tween = gsap.to(window, {
      paused: true,
      duration,
      scrollTo: 0,
      ease: "power3.inOut",
      onStart: () => {
        addEvent([document.documentElement, document.body], ["scroll", "mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"], onScrollStop);
      },
      onComplete: () => {
        onScrollStop();
      }
    });

    const onScrollStop = () => {
      tween.kill();
      removeEvent([document.documentElement, document.body], ["scroll", "mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"], onScrollStop);
    };

    tween.play();
  }

  onTick() {
    if (window.pageYOffset > window.innerHeight && !this.shown) {
      addClass(this.el, "shown");
      this.shown = true;
    } else if (window.pageYOffset < window.innerHeight && this.shown) {
      removeClass(this.el, "shown");
      this.shown = false;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ScrollTop.js